// extracted by mini-css-extract-plugin
export default {"table":"_1iuI","actionColumn":"_8Nxc","toggleSelectionColumn":"_1AaD","textContainer":"_3xrA","submitButton":"_1PPl"};